export default __webpack_public_path__ + "images/I9.056fb71.png";